$(function() {
  $('select.ws-region-select.ws-bikeshops-select').on('change', function() {
    window.location = $(this).val();
  });
});
